/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Chrono } from 'react-chrono';

export interface ITimelineProps {
  items?: any[];
}

// const items = [
//   {
//     title: "May 1940",
//     cardTitle: "Dunkirk",
//     url: "https://i.ibb.co/5n3h5ZJ/aurum-creative1.jpg",
//     cardSubtitle: "Men of the British Expeditionary Force (BEF) wade out to..",
//     cardDetailedText:
//       "Men of the British Expeditionary Force (BEF) wade out to..",
//     media: {
//       type: "IMAGE",
//       source: {
//         url: "https://i.ibb.co/5n3h5ZJ/aurum-creative1.jpg",
//       },
//     },
//   },
//   {
//     title: "May 1940",
//     cardTitle: "Dunkirk",
//     url: "http://www.history.com",
//     cardSubtitle: "Men of the British Expeditionary Force (BEF) wade out to..",
//     cardDetailedText:
//       "Men of the British Expeditionary Force (BEF) wade out to..",
//     media: {
//       type: "IMAGE",
//       source: {
//         url: "https://i.ibb.co/5n3h5ZJ/aurum-creative1.jpg",
//       },
//     },
//   },
// ];

export const TimelineComp = (props: ITimelineProps) => {
  const { items } = props;

  //   if (items && Array.isArray(items) && items.length === 0) return null;
  return <Chrono items={items} {...props} />;
};

TimelineComp.defaultProps = {};
